<template>
  <div class="aliyun-sms-config">
    <!-- 超级管理员：基础配置 + 模板与签名 -->
  
    <template v-if="isSuperTenant">
      <a-card :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-model-item label="租户用户名">
                  <a-input v-model="query.chargeUsername" placeholder="请输入租户用户名" allow-clear />
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="水司名称">
                  <a-input v-model="query.tenantName" placeholder="请输入水司名称" allow-clear />
                </a-form-model-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-space>
                  <a-button type="primary" @click="loadConfigList">查询</a-button>
                  <a-button @click="handleResetQuery">重置</a-button>
                  <a-button type="danger" @click="handleBatchDelete">删除</a-button>
                  <a-button type="primary" @click="handleAddConfig">
                    <a-icon type="plus" /> 新增配置
                  </a-button>
                </a-space>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table
          row-key="id"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :data-source="configList"
          :columns="adminColumns"
          :loading="listLoading"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <template slot="isApply" slot-scope="text">
            <a-tag :color="text ? 'green' : 'red'">{{ text ? '启用' : '禁用' }}</a-tag>
          </template>
          <div slot="action" slot-scope="text, record">
            <a @click="handleViewDetail(record)">详情</a>
          </div>
        </a-table>
      </a-card>

      <!-- 新增/编辑配置弹窗 -->
      <a-modal
        title="阿里云短信配置"
        :visible="modalVisible"
        :width="560"
        @cancel="handleModalCancel"
        @ok="handleModalOk"
      >
        <a-alert
          message="请从阿里云控制台获取您的AccessKey。为了安全，建议使用RAM子账号并授予 AliyunSMSFullAccess 权限。"
          type="info"
          show-icon
          style="margin-bottom: 16px"
        />
        <a-form-model ref="modalForm" :model="modalForm" :rules="modalRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item label="租户选择:" prop="tenantId">
            <a-select
              v-model="modalForm.tenantId"
              placeholder="请选择租户"
              allow-clear
              show-search
              option-filter-prop="children"
            >
              <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">
                {{ item.chargeUsername || item.tenantId }} ({{ item.tenantName || '' }})
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="accessKeyId:" prop="accessKeyId">
            <a-input v-model="modalForm.accessKeyId" placeholder="请输入 accessKeyId" allow-clear />
          </a-form-model-item>
          <a-form-model-item label="*accessKeySecret:" prop="accessKeySecret">
            <a-input-password
              v-model="modalForm.accessKeySecret"
              :placeholder="isSecretMasked(modalForm.accessKeySecret) ? '已配置，输入新值可修改' : '请输入 accessKeySecret'"
              allow-clear
            />
          
          </a-form-model-item>
          <a-form-model-item label="服务接入点:" prop="endpoint">
            <a-input v-model="modalForm.endpoint" placeholder="请输入" allow-clear />
            <a-button
              type="link"
              size="small"
              :loading="testLoading"
              @click="handleTestConnectivity"
              style="margin-left: 8px"
            >
              连通性测试
            </a-button>
          </a-form-model-item>
          <a-form-model-item label="设为默认服务商:" prop="isDefault">
            <a-switch v-model="modalForm.isDefault" checked-children="是" un-checked-children="否" />
          </a-form-model-item>
          <a-form-model-item label="是否启用:" prop="isApply">
            <a-switch v-model="modalForm.isApply" checked-children="启用" un-checked-children="禁用" />
          </a-form-model-item>
        </a-form-model> 
      </a-modal>
    </template>
    <!-- 其他账号：列表 + 新增配置弹窗 -->
    <template v-else>
      <a-card :bordered="false">
        <a-tabs v-model="activeTab">
          <a-tab-pane key="basic" tab="基础配置">
            <template #tab>
              <span><a-icon type="mobile" /> 基础配置</span>
            </template>
            <div class="basic-config">
              <a-alert
                message="请从阿里云控制台获取您的AccessKey。为了安全，建议使用 RAM 子账号并授予 AliyunSMSFullAccess 权限。"
                type="info"
                show-icon
                style="margin-bottom: 24px"
              />
              <a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
                <a-form-model-item label="accessKeyId">
                  <a-input v-model="form.accessKeyId" placeholder="请输入 accessKeyId" allow-clear />
                </a-form-model-item>
                <a-form-model-item label="accessKeySecret">
                  <a-input-password
                    v-model="form.accessKeySecret"
                    :placeholder="isSecretMasked(form.accessKeySecret) ? '已配置，输入新值可修改' : '请输入 accessKeySecret'"
                    allow-clear
                  />
                </a-form-model-item>
                <a-form-model-item label="服务接入点">
                  <a-input v-model="form.endpoint" placeholder="请输入 endpoint（服务接入点）" allow-clear />
                </a-form-model-item>
                <a-form-model-item label="设为默认服务商">
                  <a-switch v-model="form.isDefault" checked-children="是" un-checked-children="否" />
                </a-form-model-item>
                <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
                  <a-space>
                    <a-button type="primary" :loading="saveLoading" @click="handleSaveConfig">
                      保存配置
                    </a-button>
                <a-button :loading="testLoading" @click="handleTestConnectivity">
                      <a-icon type="sync" /> 连通性测试
                    </a-button>
                  </a-space>
                </a-form-model-item>
              </a-form-model>
            </div>
          </a-tab-pane>

          <a-tab-pane key="template" tab="模板与签名">
            <template #tab>
              <span><a-icon type="desktop" /> 模板与签名</span>
            </template>
            <div class="template-config">
              <div class="template-header">
                <span class="sync-time">最后同步时间: {{ lastSyncTime || '暂无' }}</span>
                <a-button type="primary" :loading="syncLoading" @click="handleSyncAliyun">
                  <a-icon type="sync" /> 同步阿里云
                </a-button>
              </div>
              <a-table
                :columns="templateColumns"
                :data-source="templateList"
                :loading="templateLoading"
                :pagination="templatePagination"
                :row-key="(record, index) => `template-${index}`"
                size="middle"
                @change="handleTemplateTableChange"
              >
                <template slot="templateType" slot-scope="type">
                  {{ getTemplateTypeText(type) }}
                </template>
                <template slot="auditStatus" slot-scope="status">
                  <a-tag :color="getAuditStatusColor(status)">
                    <a-icon :type="status === 'AUDIT_STATE_PASS' ? 'check-circle' : (status === 'AUDIT_STATE_NOT_PASS' ? 'close-circle' : 'clock-circle')" />
                    {{ getAuditStatusText(status) }}
                  </a-tag>
                </template>
              </a-table>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </template>
  </div>
</template>

<script>
import storage from 'store'
import { getAliyunKey, addAliyunKey, deleteAliyunKey, testAliyunConnectivity, syncAliyunTemplates, getAliyunTemplates } from '@/api/aliyunSms'

const SUPER_TENANT_ID = 'default-super-tenant2'

// 模板类型：0 短信通知 1 推广短信 2 验证码短信 6 国际/港澳台短信
const TEMPLATE_TYPE_MAP = {
  0: '短信通知',
  1: '推广短信',
  2: '验证码短信',
  6: '国际/港澳台短信'
}

// 审核状态：AUDIT_STATE_INIT 审核中 / AUDIT_STATE_PASS 通过 / AUDIT_STATE_NOT_PASS 未通过 / AUDIT_SATE_CANCEL 取消（后端拼写）
const AUDIT_STATUS_MAP = {
  AUDIT_STATE_INIT: { text: '审核中', color: 'blue' },
  AUDIT_STATE_PASS: { text: '通过审核', color: 'green' },
  AUDIT_STATE_NOT_PASS: { text: '未通过审核', color: 'red' },
  AUDIT_SATE_CANCEL: { text: '取消审核', color: 'default' }
}

export default {
  name: 'AliyunSmsConfig',
  data () {
    return {
      activeTab: 'basic',
      form: {
        id: null,
        accessKeyId: '',
        accessKeySecret: '',
        endpoint: '',
        isApply: true,
        isDefault: true,
        tenantId: ''
      },
      saveLoading: false,
      testLoading: false,
      syncLoading: false,
      templateLoading: false,
      lastSyncTime: '',
      templateList: [],
      templatePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (t) => `共 ${t} 条`
      },
      templateColumns: [
        { title: '模板名称', dataIndex: 'templateName', key: 'templateName', width: 150 },
        { title: '模板签名', dataIndex: 'signatureName', key: 'signatureName', width: 120 },
        { title: '模板内容', dataIndex: 'templateContent', key: 'templateContent', ellipsis: true },
        { title: '模板类型', dataIndex: 'templateType', key: 'templateType', width: 130, scopedSlots: { customRender: 'templateType' } },
        { title: '审核状态', dataIndex: 'auditStatus', key: 'auditStatus', width: 120, scopedSlots: { customRender: 'auditStatus' } },
        { title: '同步时间', dataIndex: 'updateTime', key: 'updateTime', width: 160 }
      ],
      // 管理员视图
      query: { chargeUsername: '', tenantName: '' },
      configList: [],
      listLoading: false,
      selectedRowKeys: [],
      tenantList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (t) => `共 ${t} 条`
      },
      adminColumns: [
        { title: '租户用户名', dataIndex: 'chargeUsername', key: 'chargeUsername', width: 120 },
        { title: '水司名称', dataIndex: 'tenantName', key: 'tenantName', width: 120 },
        { title: 'accessKeyId', dataIndex: 'accessKeyId', key: 'accessKeyId', ellipsis: true },
        { title: '启用/禁用状态', dataIndex: 'isApply', key: 'isApply', width: 120, scopedSlots: { customRender: 'isApply' } },
        { title: '配置时间', dataIndex: 'updateTime', key: 'updateTime', width: 180 },
        { title: '操作', key: 'action', width: 80, scopedSlots: { customRender: 'action' } }
      ],
      modalVisible: false,
      modalForm: {
        id: null,
        tenantId: undefined,
        accessKeyId: '',
        accessKeySecret: '',
        endpoint: '',
        isApply: true,
        isDefault: true
      },
      modalRules: {
        tenantId: [{ required: true, message: '请选择租户' }],
        accessKeyId: [{ required: true, message: '请输入 accessKeyId' }],
        accessKeySecret: [{
          validator: (rule, value, callback) => {
            if (this.isSecretMasked(this.modalForm.accessKeySecret)) return callback()
            if (!value || !value.trim()) {
              if (this.modalForm.id) return callback()
              return callback(new Error('请输入 accessKeySecret'))
            }
            callback()
          }
        }]
      }
    }
  },
  computed: {
    isSuperTenant () {
      return storage.get('tenantId') === SUPER_TENANT_ID
    }
  },
  created () {
    if (this.isSuperTenant) {
     
      this.loadTenantList()
      this.loadConfigList()
    } else {
      this.loadConfig()
    }
  },
  watch: {
    activeTab (key) {
      if (key === 'template') {
        this.loadTemplates()
      }
    }
  },
  methods: {
    // 判断 accessKeySecret 是否为加密脱敏格式（含*则不修改）
    isSecretMasked (val) {
      return val && typeof val === 'string' && val.includes('*')
    },

    // ========== 超级管理员视图 ==========
    async loadConfig () {
      try {
        const res = await getAliyunKey({ pageNum: 1, pageSize: 10 })
        const list = res?.rows || []
        if (list.length > 0) {
          const item = list[0]
          this.form = {
            id: item.id,
            accessKeyId: item.accessKeyId || '',
            accessKeySecret: item.accessKeySecret || '',
            endpoint: item.endpoint || '',
            isApply: item.isApply !== false,
            isDefault: (item.isDefault === false || item.isDefault === 0 || item.isDefault === '0') ? false : true,
            tenantId: item.tenantId || ''
          }
        }
      } catch (e) {
        console.error('加载配置失败:', e)
      }
    },

    async handleSaveConfig () {
      this.saveLoading = true
      try {
        const payload = {
          id: this.form.id,
          accessKeyId: this.form.accessKeyId,
          endpoint: this.form.endpoint || undefined,
          isApply: this.form.isApply,
          isDefault: this.form.isDefault,
          tenantId: this.form.tenantId || undefined
        }
        if (!this.isSecretMasked(this.form.accessKeySecret)) {
          payload.accessKeySecret = this.form.accessKeySecret
        }
        await addAliyunKey(payload)
        this.$message.success('保存成功')
        this.loadConfig()
      } catch (e) {
        console.error('保存失败:', e)
      } finally {
        this.saveLoading = false
      }
    },

    async handleTestConnectivity () {
      this.testLoading = true
      try {
        let payload = {}

        if (this.modalVisible) {
          // 管理员弹窗（新增/详情）
          const { tenantId, accessKeyId, accessKeySecret, endpoint } = this.modalForm
          if (!tenantId) {
            this.$message.warning('请先选择租户')
            return
          }

          if (this.isSecretMasked(accessKeySecret)) {
            // 详情场景：密钥已脱敏，仅传 tenantId
            payload = { tenantId }
          } else {
            // 新增/编辑场景：传完整配置
            if (!accessKeyId || !accessKeySecret) {
              this.$message.warning('请先填写 accessKeyId 和 accessKeySecret')
              return
            }
            payload = {
              accessKeyId,
              accessKeySecret,
              endpoint: endpoint || undefined,
              tenantId
            }
          }
        } else {
          // 普通租户基础配置页面
          const { tenantId, accessKeyId, accessKeySecret, endpoint } = this.form

          if (this.isSecretMasked(accessKeySecret)) {
            // 已有配置且密钥脱敏：仅通过 tenantId 进行连通性测试
            payload = { tenantId }
          } else {
            if (!accessKeyId || !accessKeySecret) {
              this.$message.warning('请先填写 accessKeyId 和 accessKeySecret')
              return
            }
            payload = {
              accessKeyId,
              accessKeySecret,
              endpoint: endpoint || undefined,
              tenantId
            }
          }
        }

        await testAliyunConnectivity(payload)
        this.$message.success('连通性测试通过')
      } catch (e) {
        this.$message.error(e?.response?.data?.message || '连通性测试失败，请检查配置')
      } finally {
        this.testLoading = false
      }
    },

    async handleSyncAliyun () {
      this.syncLoading = true
      try {
        await syncAliyunTemplates()
        this.$message.success('同步成功')
        this.lastSyncTime = this.formatDateTime(new Date())
        this.loadTemplates()
      } catch (e) {
        this.$message.error(e?.response?.data?.message || '同步失败')
      } finally {
        this.syncLoading = false
      }
    },

    // 接口返回 rows[].aliyunTemplateVos，展平为表格行；支持分页
    async loadTemplates () {
      this.templateLoading = true
      try {
        const { current, pageSize } = this.templatePagination
        const res = await getAliyunTemplates({ pageNum: current, pageSize })
        const rows = res?.rows || []
        const flat = rows.flatMap(r => r.aliyunTemplateVos || [])
        this.templateList = flat
        const total = res?.total != null ? Number(res.total) : 0
        this.templatePagination.total = total
        if (flat.length > 0 && !this.lastSyncTime) {
          this.lastSyncTime = flat[0].updateTime || rows[0]?.updateTime || ''
        }
      } catch (e) {
        this.templateList = []
      } finally {
        this.templateLoading = false
      }
    },

    handleTemplateTableChange (pag) {
      this.templatePagination.current = pag.current
      this.templatePagination.pageSize = pag.pageSize
      this.loadTemplates()
    },

    // 模板类型文案：0 短信通知 1 推广短信 2 验证码 6 国际/港澳台
    getTemplateTypeText (type) {
      if (type === null || type === undefined) return '—'
      return TEMPLATE_TYPE_MAP[Number(type)] != null ? TEMPLATE_TYPE_MAP[Number(type)] : `其他(${type})`
    },
    // 审核状态文案与颜色（与后端 ApiModelProperty 一致）
    getAuditStatusText (status) {
      if (!status) return '—'
      const item = AUDIT_STATUS_MAP[status]
      return item ? item.text : status
    },
    getAuditStatusColor (status) {
      if (!status) return 'default'
      const item = AUDIT_STATUS_MAP[status]
      return item ? item.color : 'default'
    },

    formatDateTime (d) {
      if (!d) return ''
      const date = d instanceof Date ? d : new Date(d)
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const min = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${day} ${h}:${min}:${s}`
    },

    // ========== 管理员视图 ==========
    // 租户选择下拉框数据来源：manager/tenants/all
    loadTenantList () {
      this.$http.get('/manager/tenants/all').then(({ data }) => {
        this.tenantList = data || []
      }).catch(() => {})
    },

    async loadConfigList () {
      this.listLoading = true
      try {
        const res = await getAliyunKey({
          chargeUsername: this.query.chargeUsername || undefined,
          tenantName: this.query.tenantName || undefined,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        })
        const list = res?.rows 
        const total = res?.total
        this.configList = list
        this.pagination.total = total
      } catch (e) {
        this.configList = []
      } finally {
        this.listLoading = false
      }
    },

    handleResetQuery () {
      this.query = { chargeUsername: '', tenantName: '' }
      this.pagination.current = 1
      this.loadConfigList()
    },

    handleTableChange (pag) {
      this.pagination.current = pag.current
      this.pagination.pageSize = pag.pageSize
      this.loadConfigList()
    },

    onSelectChange (keys) {
      this.selectedRowKeys = keys
    },

    handleAddConfig () {
      this.modalForm = { id: null, tenantId: undefined, accessKeyId: '', accessKeySecret: '', endpoint: '', isApply: true, isDefault: true }
      this.modalVisible = true
      this.$nextTick(() => this.$refs.modalForm?.clearValidate())
    },

    handleViewDetail (record) {
      this.modalForm = {
        id: record.id,
        tenantId: record.tenantId,
        accessKeyId: record.accessKeyId || '',
        accessKeySecret: record.accessKeySecret || '',
        endpoint: record.endpoint || '',
        isApply: record.isApply !== false,
        isDefault: (record.isDefault === false || record.isDefault === 0 || record.isDefault === '0') ? false : true
      }
      this.modalVisible = true
    },

    handleModalCancel () {
      this.modalVisible = false
    },

    handleModalOk () {
      this.$refs.modalForm.validate(async (valid) => {
        if (!valid) return
        try {
          const payload = {
            id: this.modalForm.id,
            tenantId: this.modalForm.tenantId,
            accessKeyId: this.modalForm.accessKeyId,
            endpoint: this.modalForm.endpoint || undefined,
            isApply: this.modalForm.isApply,
            isDefault: this.modalForm.isDefault
          }
          if (!this.isSecretMasked(this.modalForm.accessKeySecret)) {
            payload.accessKeySecret = this.modalForm.accessKeySecret
          }
          await addAliyunKey(payload)
          this.$message.success('保存成功')
          this.modalVisible = false
          this.loadConfigList()
        } catch (e) {
          console.error('保存失败:', e)
        }
      })
    },

    async handleBatchDelete () {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择要删除的配置')
        return
      }
      this.$confirm({
        title: '确认删除所选配置？',
        content: '删除后不可恢复，请谨慎操作。',
        okText: '确认删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: async () => {
          try {
            await deleteAliyunKey(this.selectedRowKeys)
            this.$message.success('删除成功')
            this.selectedRowKeys = []
            this.loadConfigList()
          } catch (e) {
            this.$message.error(e?.response?.data?.message || '删除失败')
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.aliyun-sms-config {
  padding: 0;
}

.basic-config {
  max-width: 600px;
}

.template-config {
  .template-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .sync-time {
      color: #666;
      font-size: 14px;
    }
  }
}

/deep/ .ant-tabs-nav .ant-tabs-tab {
  padding: 12px 16px;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}
</style>
